/* Local fallback data when Sitecore is missing keys. */
import { StringKeyAnyValue, StringKeyValue } from '../actions/types';
import CustomAppTypes from './customAppTypes';
import sitecoreSimulationData from './sitecoreSimulationData';

interface Config {
    // Config String Paths
    calculatorPath: string;
    landingPagePath: string;
    applicationPath: string;
    completionPathSecuredLoan: string;
    completionPathCreditLoan: string;
    completionPathCreditLoanAdvisor: string;
    completionPathCreditCard: string;

    // Sitecore text/form keys
    text: StringKeyValue;
    form: StringKeyAnyValue;
}

const defaultLocalConfigData = {
    // Config String Paths
    calculatorPath: sitecoreSimulationData.calculatorPath,
    landingPagePath: sitecoreSimulationData.landingPagePath,
    applicationPath: sitecoreSimulationData.applicationPath,
    completionPathSecuredLoan: sitecoreSimulationData.completionPathSecuredLoan,
    completionPathCreditLoan: sitecoreSimulationData.completionPathCreditLoan,
    completionPathCreditLoanAdvisor: sitecoreSimulationData.completionPathCreditLoanAdvisor,
    completionPathCreditCard: sitecoreSimulationData.completionPathCreditCard,

    // Sitecore text/form keys
    text: sitecoreSimulationData.text,
    form: sitecoreSimulationData.form,
};

const transformLocalConfigData = (appType: string) => {
    const transformedText: StringKeyValue = { ...defaultLocalConfigData.text };
    const appTypeSpecificConfig: Config = CustomAppTypes.resolveConfig(appType);

    Object.keys(appTypeSpecificConfig.text).forEach((key) => {
        transformedText[key] = appTypeSpecificConfig.text[key];
    });

    return { ...defaultLocalConfigData, text: transformedText };
};

const resolveLocalConfigData = (appType: string, defaultAppType: string): Config => {
    return appType === defaultAppType ? defaultLocalConfigData : transformLocalConfigData(appType);
};

export default resolveLocalConfigData;
